// extracted by mini-css-extract-plugin
module.exports = {"errorPage":"styles_errorPage__4lUSY","iconWrapper":"styles_iconWrapper__6TfcA","icon":"styles_icon__2SKc7"};